import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import type { WizardContext } from '@swf/core/types/Wizard';

import { handleEffectResponse } from '../utils/handleEffectResponse';

const useUpdateRmfMitID = () => {
  const {
    account: { updateAccount }
  } = useDispatch<Dispatch>();

  return useCallback(
    async ({ data: { mitIdResultContext } }: Pick<WizardContext, 'data'>) => {
      const payload = mitIdResultContext
        ? { realMoneyFlag: true, ...mitIdResultContext }
        : { realMoneyFlag: true };

      const response = await updateAccount(payload);
      if (!response.success) {
        return handleEffectResponse(response);
      } else {
        return { rmfPassed: true };
      }
    },
    [updateAccount]
  );
};
export default useUpdateRmfMitID;
